<template>
  <div class="Fiche" :class="horiz ? 'Fiche__horiz' : ''"><slot></slot></div>
</template>

<script>
export default {
  name: "Fiche",
  props: {
    horiz: {}
  }
};
</script>
